import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';
import { flagContents, INTERNATIONAL_FLAG_CODE } from 'src/ui/assets/icons/flags/flagContents';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface CountryFlagIconPropsType {
    className?: string;
    dataTest?: string;
    flagCode: string | null;
    onClick?: () => void;
}

export const CountryFlagIcon = observer(
    'CountryFlagIcon',
    ({ className, dataTest, flagCode, onClick }: CountryFlagIconPropsType): JSX.Element => {
        const code = flagCode === null ? INTERNATIONAL_FLAG_CODE : flagCode.toLowerCase();
        const internationalContent = flagContents[INTERNATIONAL_FLAG_CODE];

        if (internationalContent === undefined) {
            throw new Error(`CountryFlagIcon: missing required '${INTERNATIONAL_FLAG_CODE}' fallback content`);
        }

        const content = flagContents[code] ?? internationalContent;

        return (
            <SvgElement
                className={className}
                data-test={dataTest ?? 'country-flag'}
                onClick={onClick}
                width='28'
                height='20'
                viewBox='0 0 28 20'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
            >
                {content}
            </SvgElement>
        );
    }
);
